import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#172554] py-12 text-sm text-slate-300">
    <div className="mx-auto flex max-w-7xl flex-col gap-8 px-4 sm:px-6 md:flex-row md:items-end md:justify-between lg:px-8">
      <div data-testid="footer-company-info">
        <Logo light />
        <p className="mt-4"><strong className="text-white">AffittoSicuro S.r.l.</strong> - P.IVA 12345678901</p>
        <p className="mt-1">Tutti i diritti riservati. Piattaforma conforme al Regolamento UE 2016/679 (GDPR).</p>
      </div>
      <p className="flex flex-wrap gap-x-5 gap-y-2">
        <a href="#" data-testid="footer-link-privacy" className="text-[#93c5fd] hover:text-white">Informativa sulla Privacy</a>
        <a href="#" data-testid="footer-link-termini" className="text-[#93c5fd] hover:text-white">Termini di Servizio</a>
        <a href="#" data-testid="footer-link-note-legali" className="text-[#93c5fd] hover:text-white">Note Legali</a>
      </p>
    </div>
  </footer>
);
